<template>
  <div class="ui modal" id="create-content-modal">
    <i class="close inside icon" />
    <div class="header">Create Content</div>
    <div class="scrolling content">
      <ChoiceGrid data-testid="choice-grid" v-if="page === 1" :choices="choices" ref="grid" />
      <Form data-testid="form" v-if="type === 'new-content'" ref="contentForm" @validChange="value => formValid = value">Page 2</Form>
      <div class="ui icon message" v-if="showMessage">
        <i class="save icon"></i>
        <div class="content">
          Upon Save you will be taken to your new Content Profile where you can
          begin editing immediately even while the video upload is still
          processing.
        </div>
      </div>
    </div>
    <ConfirmationModal
      ref="confirm"
      id="confirm-back"
      title="Confirm Navigation"
      content="Navigating back will not save changes, are you sure you want to continue?"
      @actionTaken="reset"
    />
    <div class="actions">
      <template v-if="type">
        <button class="ui left floated grey button" @click="previous">
          Back
        </button>
        <button class="ui green button" @click="save" :disabled="!formValid">Save</button>
      </template>
      <button v-else class="ui green button" @click="next">Continue</button>
      <button class="ui grey button" @click="hideModal">Cancel</button>
    </div>
  </div>
</template>

<script>
import Form from './Form';
import ConfirmationModal from '@/components/shared/modals/ConfirmationModal';
import ChoiceGrid from '@/components/shared/modals/ChoiceGrid';
import ContentService from '@/services/api/custom-content/custom-content-service.js';

export default {
  name: 'CreateContent',
  components: {
    Form,
    ConfirmationModal,
    ChoiceGrid,
  },
  data() {
    return {
      choices: [
        {
          title: 'Create Content',
          type: 'new-content',
          icon: require('@/assets/create-new-folder.svg'),
        },
        {
          title: 'Customize BizLibrary Content',
          type: 'existing-content',
          icon: require('@/assets/existing-folder.svg'),
        },
      ],
      type: null,
      page: 1,
      formValid: false,
    };
  },
  computed: {
    showMessage() {
      return this.page === 2;
    },
  },
  methods: {
    showModal() {
      this.reset();
      $('#create-content-modal').modal({
        allowMultiple: true,
        detachable: false,
      });
      this.showModals('#create-content-modal');
    },
    hideModal() {
      $('#create-content-modal').modal('hide');
    },
    previous() {
      this.page = 1;
      if (this.$refs.contentForm.isDirty) {
        this.$refs.confirm.showModal();
      } else {
        this.reset();
      }
    },
    next() {
      this.type = this.$refs.grid.selected;
      if (this.type === 'existing-content') {
        this.hideModal();
        this.$router.push({
          name: 'bizlibrary-content',
          query: {
            filters: JSON.stringify([{ content_features: 'Customizable' }]),
          },
        });
      } else {
        this.page = 2;
      }
    },
    save() {
      if (this.$refs.contentForm.validate()) {
        ContentService.createCustomContent(this.$refs.contentForm.newValue)
          .then(res => {
            this.$store.dispatch('uploadVideo', {
              url: res.videoUploadUrl,
              file: this.$refs.contentForm.video,
              headers: res.headers,
            });
            this.$router.push({
              name: 'custom-content-details',
              params: { syncguid: res.syncguid },
            });
            this.showToast({
              class: 'success',
              message: 'Content successfully created.',
            });
            this.showToast({
              class: 'warning',
              message:
                'Your video is currently uploading.  Please do not close the application.',
              displayTime: 0,
            });
          })
          .catch(() => {
            this.showToast({
              class: 'error',
              message: 'An error occurred while creating the content.',
            });
          });
        this.$gtag.event('Create Custom', {
          event_category: 'Custom',
          event_label: 'Custom Content Created',
        });
        this.hideModal();
      }
    },
    showToast(params) {
      $('body').toast(params);
    },
    reset() {
      if (this.$refs.grid) {
        this.$refs.grid.selected = this.choices[0].type;
      }
      this.page = 1;
      this.type = null;
    },
  },
};
</script>
